<template>
  <div>
    <communication-item-text v-if="isText(comm)" :text="comm">
      <template v-slot:column>
        <communication-item-records :communication-log="comm"></communication-item-records>
      </template>
    </communication-item-text>

    <communication-item-call v-if="isCall(comm)" :call="comm">
      <template v-slot:column>
        <communication-item-records :communication-log="comm"></communication-item-records>
      </template>
    </communication-item-call>

    <communication-item-email v-if="isEmail(comm)" :email="comm">
      <template v-slot:column>
        <communication-item-records :communication-log="comm"></communication-item-records>
      </template>
    </communication-item-email>
  </div>
</template>

<script>
import {ENUMS} from "../../../services/enums";
import CommunicationItemText from "./CommunicationItemText";
import CommunicationItemCall from "./CommunicationItemCall";
import CommunicationItemEmail from "./CommunicationItemEmail";
import CommunicationItemRecords from "./CommunicationItemRecords";

export default {
  name: "CommunicationEntry",
  components: {
    CommunicationItemRecords,
    CommunicationItemEmail,
    CommunicationItemCall,
    CommunicationItemText,
  },
  props: {
    comm: Object,
  },
  methods: {
    isText(comm) {
      return comm.type === ENUMS.CommunicationTypeEnum.Text.value;
    },
    isCall(comm) {
      if (comm.type === ENUMS.CommunicationTypeEnum.VideoCall.value) {
        return true;
      }

      return comm.type === ENUMS.CommunicationTypeEnum.Call.value;
    },
    isEmail(comm) {
      return comm.type === ENUMS.CommunicationTypeEnum.Email.value;
    },
  },
}
</script>
